/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Credits_TitleInputs */

const en_landing_features_credits_title = /** @type {(inputs: Landing_Features_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit System`)
};

const zh_landing_features_credits_title = /** @type {(inputs: Landing_Features_Credits_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`积分系统`)
};

/**
* | output |
* | --- |
* | "Credit System" |
*
* @param {Landing_Features_Credits_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_credits_title = /** @type {((inputs?: Landing_Features_Credits_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Credits_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_credits_title(inputs)
	return zh_landing_features_credits_title(inputs)
});
export { landing_features_credits_title as "landing.features.credits.title" }